import { render, staticRenderFns } from "./new-inquiry.vue?vue&type=template&id=6b73b39c"
import script from "./new-inquiry.vue?vue&type=script&lang=js"
export * from "./new-inquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports